module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_feeling03_gray-b1f5365300198b9299226417ed1595e4.svg";